<template>
  <section class="edit-policy-form width-700">
    <!--    <el-form-->
    <!--      ref="form"-->
    <!--      :disabled="showBuyable"-->
    <!--      :rules="formRules"-->
    <!--      :model="formData">-->
    <!--      <div class="box">-->
    <!--        <h3>More Benefits</h3>-->
    <!--        <div class="form-item">-->
    <!--          <v-checkbox-group-->
    <!--            v-model="formData.benefits"-->
    <!--            :block="true"-->
    <!--            :list="localAllOptions.benefits" />-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </el-form>-->
    <fire-policy-form
      ref="policy-form"
      :form="form"
      :isRequired="isRequired"
      :editType="editType"
      :showBuyable="showBuyable"
      :checkRefer="checkRefer"
      @getFormData="getFormData" />
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import firePolicyForm from '@/views/quoting/modules/homefire/form/fire-policy-form'

export default {
  components: {
    firePolicyForm
  },
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formData: {
        // benefits: []
      }
    }
  },
  computed: {
    localAllOptions() {
      return this.allOptions29
    },
    formRules() {
      let rulesOption = JSON.stringify(this.rules)
      rulesOption = JSON.parse(rulesOption)

      Object.keys(rulesOption).some(keys => {
        rulesOption[keys][0].required = false
      })

      Object.keys(this.ruleRequestData).some(key => {
        // Object.keys(rulesOption).some(keys => {
        //   if(key==keys)
        rulesOption[key][0].required = true
        // })
      })
      return this.checkRefer ===2 ? this.rules : rulesOption
      // return this.rules
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          Object.keys(this.formData).some(key => {
            if(key in val) {
              this.formData[key] = val[key]
            }
          })
        }
      }
    },
    // editType: {
    //   immediate: true,
    //   handler(val) {
    //     this.requireValid = val === 2? true: false
    //   }
    // },
  },
  methods: {
    submitForm(otherData = {}) {
      this.$refs['policy-form'].submitForm(otherData)
      // this.$refs['form'].validate(valid => {
      //   if(valid) {
      //
      //   }
      // })

    },
    getSubmitFormNoValid(otherData = {}){
      this.$refs['policy-form'].getSaveSubmitForm(otherData)
    },
    getFormData(data, otherData) {
      // 整合其他數據
      const result = {
        ...data,
        ...this.formData
      }
      this.$emit('getFormData', result, otherData)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>